import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    fetching: true,
    fetchingIds: [],
    error: {
        status: null,
        type: null,
    },
    data: {},
};

const kwOpportunitiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.DATA_KW_OPPORTUNITIES_FETCHING: {
            return update(state, {
                fetching: { $set: true },
                fetchingIds: { $set: action?.payload?.keywordIds || [] },
            });
        }
        case ActionTypes.DATA_KW_OPPORTUNITIES_RECEIVED: {
            const newData = {
                ...state.data,
                ...action.payload
            };

            return update(state, {
                fetching: { $set: false },
                fetchingIds: { $set: [] },
                data: { $set: newData },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_SINGLE_KW_OPPORTUNITIES_RECEIVED: {
            const newData = {
                ...state.data,
                ...action.payload
            };
            return update(state, {
                data: { $set: newData },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_KW_OPPORTUNITIES_ERROR: {
            return update(state, {
                data: { $set: initialState.data },
                fetchingIds: { $set: [] },
                fetching: { $set: false },
                error: {
                    status: { $set: action.payload.status },
                    type: { $set: action.payload.type },
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default kwOpportunitiesReducer;